module.exports = __webpack_public_path__ + "img/315.0a8eac9f.png";